"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedInseeCode = exports.getInseeCodeFromLegalForm = exports.getLegalFormFromInseeCode = void 0;
const legalForms_1 = require("../constants/legalForms");
const INSEE_CODE_TO_LEGAL_FORMS = {
    '1000': legalForms_1.LEGAL_FORMS.EI,
    '2385': legalForms_1.LEGAL_FORMS.SPFPL,
    '5202': legalForms_1.LEGAL_FORMS.SNC,
    '5203': legalForms_1.LEGAL_FORMS.SNC,
    '5306': legalForms_1.LEGAL_FORMS.SA,
    '5307': legalForms_1.LEGAL_FORMS.SA,
    '5308': legalForms_1.LEGAL_FORMS.SA,
    '5309': legalForms_1.LEGAL_FORMS.SA,
    '5370': legalForms_1.LEGAL_FORMS.SPFPL,
    '5385': legalForms_1.LEGAL_FORMS.SA,
    '5410': legalForms_1.LEGAL_FORMS.SARL,
    '5426': legalForms_1.LEGAL_FORMS.SARL,
    '5431': legalForms_1.LEGAL_FORMS.SARL,
    '5442': legalForms_1.LEGAL_FORMS.SARL,
    '5443': legalForms_1.LEGAL_FORMS.SARL,
    '5453': legalForms_1.LEGAL_FORMS.SARL,
    '5455': legalForms_1.LEGAL_FORMS.SARL,
    '5458': legalForms_1.LEGAL_FORMS.SARL,
    '5459': legalForms_1.LEGAL_FORMS.SARL,
    '5460': legalForms_1.LEGAL_FORMS.SARL,
    '5470': legalForms_1.LEGAL_FORMS.SPFPL,
    '5485': legalForms_1.LEGAL_FORMS.SELARL,
    '5498': legalForms_1.LEGAL_FORMS.EURL,
    '5499': legalForms_1.LEGAL_FORMS.SARL,
    '5505': legalForms_1.LEGAL_FORMS.SA,
    '5522': legalForms_1.LEGAL_FORMS.SA,
    '5531': legalForms_1.LEGAL_FORMS.SA,
    '5532': legalForms_1.LEGAL_FORMS.SA,
    '5542': legalForms_1.LEGAL_FORMS.SA,
    '5543': legalForms_1.LEGAL_FORMS.SA,
    '5551': legalForms_1.LEGAL_FORMS.SA,
    '5552': legalForms_1.LEGAL_FORMS.SA,
    '5553': legalForms_1.LEGAL_FORMS.SA,
    '5554': legalForms_1.LEGAL_FORMS.SA,
    '5555': legalForms_1.LEGAL_FORMS.SA,
    '5558': legalForms_1.LEGAL_FORMS.SA,
    '5559': legalForms_1.LEGAL_FORMS.SA,
    '5560': legalForms_1.LEGAL_FORMS.SA,
    '5585': legalForms_1.LEGAL_FORMS.SA,
    '5599': legalForms_1.LEGAL_FORMS.SA,
    '5605': legalForms_1.LEGAL_FORMS.SA,
    '5631': legalForms_1.LEGAL_FORMS.SA,
    '5632': legalForms_1.LEGAL_FORMS.SA,
    '5642': legalForms_1.LEGAL_FORMS.SA,
    '5643': legalForms_1.LEGAL_FORMS.SA,
    '5651': legalForms_1.LEGAL_FORMS.SA,
    '5652': legalForms_1.LEGAL_FORMS.SA,
    '5653': legalForms_1.LEGAL_FORMS.SA,
    '5654': legalForms_1.LEGAL_FORMS.SA,
    '5655': legalForms_1.LEGAL_FORMS.SA,
    '5658': legalForms_1.LEGAL_FORMS.SA,
    '5659': legalForms_1.LEGAL_FORMS.SA,
    '5670': legalForms_1.LEGAL_FORMS.SPFPL,
    '5685': legalForms_1.LEGAL_FORMS.SA,
    '5699': legalForms_1.LEGAL_FORMS.SA,
    '5710': legalForms_1.LEGAL_FORMS.SAS,
    '5720': legalForms_1.LEGAL_FORMS.SASU,
    '5770': legalForms_1.LEGAL_FORMS.SPFPL,
    '5785': legalForms_1.LEGAL_FORMS.SARL,
    '5800': legalForms_1.LEGAL_FORMS.SE,
    '6316': legalForms_1.LEGAL_FORMS.G_AGRI,
    '6317': legalForms_1.LEGAL_FORMS.G_AGRI,
    '6511': legalForms_1.LEGAL_FORMS.OTHER,
    '6533': legalForms_1.LEGAL_FORMS.GAEC,
    '6534': legalForms_1.LEGAL_FORMS.G_AGRI,
    '6536': legalForms_1.LEGAL_FORMS.G_AGRI,
    '6539': legalForms_1.LEGAL_FORMS.SC,
    '6540': legalForms_1.LEGAL_FORMS.SCI,
    '6543': legalForms_1.LEGAL_FORMS.SC,
    '6544': legalForms_1.LEGAL_FORMS.SCI,
    '6554': legalForms_1.LEGAL_FORMS.SC,
    '6558': legalForms_1.LEGAL_FORMS.SC,
    '6560': legalForms_1.LEGAL_FORMS.SC,
    '6561': legalForms_1.LEGAL_FORMS.SCP,
    '6562': legalForms_1.LEGAL_FORMS.SCP,
    '6563': legalForms_1.LEGAL_FORMS.SCP,
    '6564': legalForms_1.LEGAL_FORMS.SCP,
    '6565': legalForms_1.LEGAL_FORMS.SCP,
    '6566': legalForms_1.LEGAL_FORMS.SCP,
    '6567': legalForms_1.LEGAL_FORMS.SCP,
    '6568': legalForms_1.LEGAL_FORMS.SCP,
    '6569': legalForms_1.LEGAL_FORMS.SCP,
    '6571': legalForms_1.LEGAL_FORMS.SCP,
    '6572': legalForms_1.LEGAL_FORMS.SCP,
    '6573': legalForms_1.LEGAL_FORMS.SCP,
    '6574': legalForms_1.LEGAL_FORMS.SCP,
    '6575': legalForms_1.LEGAL_FORMS.SCP,
    '6576': legalForms_1.LEGAL_FORMS.SCP,
    '6577': legalForms_1.LEGAL_FORMS.SCP,
    '6578': legalForms_1.LEGAL_FORMS.SCP,
    '6585': legalForms_1.LEGAL_FORMS.SC,
    '6588': legalForms_1.LEGAL_FORMS.SC,
    '6589': legalForms_1.LEGAL_FORMS.SCM,
    '6597': legalForms_1.LEGAL_FORMS.SC,
    '6598': legalForms_1.LEGAL_FORMS.EARL,
    '6599': legalForms_1.LEGAL_FORMS.SC,
    '9224': legalForms_1.LEGAL_FORMS.AARPI,
};
function getLegalFormFromInseeCode(inseeCode) {
    return INSEE_CODE_TO_LEGAL_FORMS[inseeCode];
}
exports.getLegalFormFromInseeCode = getLegalFormFromInseeCode;
function getInseeCodeFromLegalForm(legalForm) {
    switch (legalForm) {
        case legalForms_1.LEGAL_FORMS.EARL:
            return '6598';
        case legalForms_1.LEGAL_FORMS.EI:
            return '1000';
        case legalForms_1.LEGAL_FORMS.GAEC:
            return '6533';
        case legalForms_1.LEGAL_FORMS.SARL:
            return '5499';
        case legalForms_1.LEGAL_FORMS.SAS:
            return '5710';
        case legalForms_1.LEGAL_FORMS.SELARL:
            return '5485';
        case legalForms_1.LEGAL_FORMS.SCI:
            return '6540';
        case legalForms_1.LEGAL_FORMS.SCM:
            return '6589';
        case legalForms_1.LEGAL_FORMS.SNC:
            return '5202';
        default:
            return undefined;
    }
}
exports.getInseeCodeFromLegalForm = getInseeCodeFromLegalForm;
function isSupportedInseeCode(inseeCode) {
    return !!INSEE_CODE_TO_LEGAL_FORMS[inseeCode];
}
exports.isSupportedInseeCode = isSupportedInseeCode;
